;(function() {
/* @ngInject */
function ZmenaZivnostiKrok2Controller(ZmenaZivnostiKrok2Service, UserService, $window, routes, Helpers, ModalFinishLater, $scope) {
  let vm = this;
  let server = ZmenaZivnostiKrok2Service;
  vm.server = server;

  let userService = UserService;

  vm.maxStep = 2;
  vm.order = {};
  vm.requiredCheckbox = false;
  vm.donation = 0;

  vm.onBackClick = onBackClick;
  vm.onFinishClick = onFinishClick;
  vm.onSaveForLaterClick = onSaveForLaterClick;
  vm.scrollTo = Helpers.scrollTo;
  vm.mergeStreetNo = Helpers.mergeStreetNo;
  vm.phoneNumberToString = Helpers.phoneNumberToString;

  vm.cart = {
    finalPrice: 0
  };

  vm.inProgress = false;

  vm.agreements = {
    agrees: false,
    representation: true
  };

  vm.upsells = {
    tb: {
      active: false,
      agree: false
    },
    superfaktura: {
      active: false,
      agree: false
    },
    znamka: {
      active: false
    }
  };

  vm.orderId = 0;
  vm.user = {};

  vm.zvyhodnena = false;
  vm.ip = "";
  vm.totalPriceWithoutDonation = 0;

  window.showSpinner(6);
  server.getOrder().then((order) => { vm.order = order; window.hideSpinnerWhenAllResolved(); });
  server.getMaxStep().then((ms) => {vm.maxStep = ms; window.hideSpinnerWhenAllResolved(); });
  server.getDonation().then((d) => vm.donation = d);
  server.getCart().then(onPriceLoad);
  server.getTotalPriceWithoutDonation().then((price => vm.totalPriceWithoutDonation = price));
  server.getOrderId().then((id) => { vm.orderId = id; window.hideSpinnerWhenAllResolved(); });
  server.getUpsell().then((upsell) => { vm.upsells = upsell; window.hideSpinnerWhenAllResolved(); });
  server.getIPAddress().then((ip) => vm.ip = ip);
  userService.getLoggedUser().then((user) => {vm.user = user; window.hideSpinnerWhenAllResolved()});
  userService.isOldUser().then((ms) => vm.zvyhodnena = ms);

  $scope.$on('on-price-change', function(event, args) {
    server.getCart().then(onPriceLoad);
  });

  $scope.$watch('vm.donation', function () {
    server.setDonation(vm.donation.toString()).then(server.getCart().then(onPriceLoad));
  }, true);

  function onPriceLoad(cart) {
    vm.cart = cart;

    window.hideSpinnerWhenAllResolved();
  }

  function formatDate(dateOfBirth) {
    return dateOfBirth.day.concat(".", dateOfBirth.month, ".", dateOfBirth.year);
  }

  function onBackClick() {
    $window.location = routes.zivnosti.zmeny.krok1;
  }

  function finishSave() {
    let consents = {
        agreements: {agrees: vm.agreements.agrees, requestsRepresentation: vm.agreements.representation},
        contactMe: vm.order.personalInfo.contactMe
    }
    server.finish(consents).then(function (_ref) {
      var success = _ref.success;
      var data = _ref.data;
      var error = _ref.error;

      if (success) {
        $window.location = routes.zivnosti.zmeny.objednane;
      }
      vm.inProgress = false;
      window.hideSpinnerWhenAllResolved();
    }).catch(function (error) {
      vm.inProgress = false;
      window.hideSpinnerWhenAllResolved();
    });
  }

  function onFinishClick() {
    if(!vm.agreements.agrees) {
      vm.requiredCheckbox = true;
      vm.scrollTo("scroll_checkbox");
    } else {
      var dataLayer = Helpers.getDataLayer(vm.orderId,
          vm.order.destroyOrPause.value === 'destroy' ? (vm.zvyhodnena ? 'zrusenie_zivnost_zvyhodnena' : 'zrusenie_zivnost') :
              (vm.order.destroyOrPause.value === 'pause' ? (vm.zvyhodnena ? 'pozastavenie_zivnost_zvyhodnena' : 'pozastavenie_zivnost') :
                  (vm.order.destroyOrPause.value === 'renew' ? (vm.zvyhodnena ? 'obnovenie_zivnost_zvyhodnena' : 'obnovenie_zivnost') :
                      (vm.zvyhodnena ? 'zmeny_zivnost_zvyhodnena' : 'zmeny_zivnost'))),
          'zivnost', '', vm.user);
      $window.localStorage.setItem('dataLayer', JSON.stringify(dataLayer));

      vm.inProgress = true;
      window.showSpinner(1);

      // TODO docasne vypnute
      // if (vm.upsells && vm.upsells.tb && vm.upsells.tb.active) {
      //   let psc = "";
      //
      //   if (vm.order.newAddressPlaceOfBussiness) {
      //     psc = vm.order.newAddressPlaceOfBussiness.zipCode;
      //   } else {
      //     psc = vm.order.personalInfo.address.zipCode;
      //   }
      //
      //   let personInfo = vm.order.personalInfo;
      //
      //   Helpers.exponeaTrack(
      //       personInfo.companyName,
      //       personInfo.name + ' ' + personInfo.surname,
      //       vm.upsells.tb.agree ? 1 : 0,
      //       vm.ip,
      //       vm.upsells.tb && vm.upsells.tb.timestampAgree ? vm.upsells.tb.timestampAgree : "",
      //       vm.phoneNumberToString(personInfo.phoneNumber),
      //       vm.order.ico,
      //       psc,
      //       vm.order.contactInfo.email,
      //       0,
      //       vm.orderId).then(result => {
      //     vm.upsells.tb.success = result;
      //     finishSave()
      //   });
      // } else
          finishSave();
    }
  }

  function onSaveForLaterClick() {
    ModalFinishLater(server)
      .add(server)
      .result
      .then();
  }


}

angular.module("firmaren")
  .controller("ZmenaZivnostiKrok2Controller", ZmenaZivnostiKrok2Controller);
}());
